export const visit = (vm, at) => {
at({ "en": { "hc-0133": { "sample-data-banner": { "title": "Sample data mode", "description": "You can explore and edit this data until you\u2019re ready to upload your own" } } } });
};